import React from "react";
import { BiLoaderAlt } from "react-icons/bi";
import logo from "../assets/images/loader.gif";

const NoEvent = () => {
  return (
    <div className="no-event-outer">
      <div className="no-event">
        <BiLoaderAlt color="lightgrey" size={55} className="mb-2"/>
          No Event
          {/* <img src={logo} loop autoPlay muted style={{ height: `150px` }} /> */}
      </div>
    </div>
  );
};

export default NoEvent;
